<div class="taly-business">
    <div class="business-logo">
        <img src="assets/images/taly-partners.svg" alt="home-logo">
        <!-- <span translate>HOME_PAGE.BUSINESS</span> -->
    </div>
    <hr>

    <div class="sales">
        <h4 translate>HOME_PAGE.SALES</h4>
    </div>
    <div class="start-now">
        <button class="btn btn-grey" routerLink="/partner" translate>
            HOME_PAGE.TELL_MORE
        </button>
        <button class="btn btn-white" routerLink="/partner/sign-up"  translate>
            HOME_PAGE.START_NOW
        </button>
    </div>
</div>